<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { Link } from 'svelte-routing';
  import { t } from '../i18nStore';

  export let cardName; 

  let users = [];
  let isLoading = true;
  let error = '';
  let promoId = null; // Store the origin promotion ID

  onMount(async () => {
      // Extract promoId from the URL query string
      const urlParams = new URLSearchParams(window.location.search);
      promoId = urlParams.get('promoId');

      try {
          const url = getApiUrl(`/users/by-card?card=${encodeURIComponent(cardName)}`);
          
          const res = await fetch(url);
          if (!res.ok) {
              const errData = await res.json().catch(() => ({}));
              throw new Error(errData.error || `Failed to load users (Error ${res.status})`);
          }
          users = await res.json();
      } catch (e) {
          error = e.message;
      } finally {
          isLoading = false;
      }
  });
</script>

<div class="cardholders-container">
  <!-- Navigation Back Link -->
  {#if promoId}
      <Link to={`/promotions/detail/${promoId}`} class="back-link">
          {$t('cardholders.back_to_promo') || '← Back to Promotion'}
      </Link>
  {/if}

  <h2>{($t('cardholders.title_with_card') || 'Users with {card}').replace('{card}', cardName)}</h2>
  <p class="subtitle">{$t('cardholders.subtitle') || 'Connect with these users to enjoy exclusive card promotions.'}</p>

  {#if isLoading}
      <div class="loading">{$t('cardholders.loading') || 'Loading users...'}</div>
  {:else if error}
      <div class="error">{error}</div>
  {:else if users.length === 0}
      <div class="no-data">{$t('cardholders.no_data') || 'No users have listed this card yet.'}</div>
  {:else}
      <div class="user-list">
          {#each users as user}
              <div class="user-card">
                  <div class="avatar">{user.displayName ? user.displayName.charAt(0).toUpperCase() : '?'}</div>
                  <div class="user-info">
                      <h3>{user.displayName || $t('cardholders.anonymous') || 'Anonymous User'}</h3>
                  </div>
                  <!-- Attach the cardName to the profile link so the profile page knows where to return -->
                  <Link to={`/user/public/${user.userId}?card=${encodeURIComponent(cardName)}`} class="btn-connect">
                      {$t('cardholders.view_profile') || 'View Profile'}
                  </Link>
              </div>
          {/each}
      </div>
  {/if}
</div>

<style>
  .cardholders-container { max-width: 800px; margin: 2rem auto; padding: 1rem; }
  
  .back-link { display: inline-block; margin-bottom: 1rem; color: #007bff; text-decoration: none; font-weight: 600; font-size: 0.95rem; }
  .back-link:hover { text-decoration: underline; color: #0056b3; }

  h2 { margin-bottom: 0.5rem; }
  .subtitle { color: #666; margin-bottom: 2rem; }
  
  .user-list { display: flex; flex-direction: column; gap: 1rem; }
  .user-card { display: flex; align-items: center; background: white; padding: 1rem 1.5rem; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
  
  .avatar { width: 50px; height: 50px; border-radius: 50%; background: #007bff; color: white; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: bold; margin-right: 1.5rem; }
  .user-info { flex: 1; }
  .user-info h3 { margin: 0; font-size: 1.1rem; color: #333; }
  
  .btn-connect { background: #f8f9fa; color: #007bff; border: 1px solid #007bff; padding: 0.5rem 1rem; border-radius: 20px; text-decoration: none; font-weight: 600; transition: all 0.2s; }
  .btn-connect:hover { background: #007bff; color: white; }
  
  .loading, .error, .no-data { text-align: center; padding: 3rem; color: #666; }
</style>